<div id="fab-dismiss"
  *ngIf="fabTogglerState==='active'"
  (click)="toggle()">
</div>

<div class="fab-container">
  <button mat-fab color="warn" class="fab-toggler" (click)="toggle()">
    <i class="material-icons" [@fabToggler]="{value: fabTogglerState}">add</i>
  </button>

  <div [@speedDialStagger]="buttons.length">
    <button 
      *ngFor="let btn of buttons"
      mat-mini-fab
      class="fab-secondary"
      color="secondary">
      <a *ngIf="btn.icon != 'settings'" [routerLink]="['']" fragment="{{btn.link}}">
        <i class="material-icons">{{btn.icon}}</i>
      </a>

      <a *ngIf="btn.icon == 'settings'" (click)="open()">
        <i class="material-icons">{{btn.icon}}</i>
      </a>
    </button>

  </div>
</div>


